module.exports = __webpack_public_path__ + "assets/wp-rocket.d35cef2a.svg";